/* AppsGrid.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D%0A._2iEGP2d3pA%7Bgrid-template-columns%3Arepeat(auto-fit%2Cminmax(252px%2C1fr))%7D%0A._0aNu0LYbGa%7Blist-style-type%3Anone%7D%0A._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D%0A._2iEGP2zezl%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(252px%2C1fr))%7D");





import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
const styles = {
  fillResponsiveGrid: "_2mHwu85zaO _2iEGP2d3pA _0aNu0LYbGa _0LQT5EPgdg _43nrzTPgdg",
  responsiveGrid: "_2mHwu85zaO _2iEGP2zezl _0aNu0LYbGa _0LQT5EPgdg _43nrzTPgdg"
};
interface Props {
  children: React.ReactNode;
  fillAvailableSpace?: boolean;
}
export const AppsGrid = ({
  children,
  fillAvailableSpace = false
}: Props): React.JSX.Element => <Grid xcss={fillAvailableSpace ? styles.fillResponsiveGrid : styles.responsiveGrid} as="ul">
		{children}
	</Grid>;